import React from 'react';

import { type SwitcherItemType } from './links';
import { FormattedMessage } from 'react-intl-next';
import messages from './messages';

export default (url: string, label?: string): SwitcherItemType => ({
	key: 'company-hub',
	iconKey: 'company-hub',
	label: label ?? <FormattedMessage {...messages.companyHub} />,
	href: url,
	productType: 'COMPANY_HUB',
});
